import { useAppSelector } from '@app/store';
import { selectFlags } from '@app/store/selectors';

export const useFlags = () => {
  const flags = useAppSelector(selectFlags);

  return flags;
};
